<template>
  <div>
    <v-container class="pa-0" fluid>
      <!-- Toolbar -->
      <v-row class="px-3" style="height: 48px; max-height: 48px">
        <ContenidoBase
          :EstadoBtn="EstadoBtn"
          :descripcion="'Anular, Reimprimir y Modificar Galones de Facturas'"
          :show-absolute="false"
          :titulo="'Auditoria de Facturas'"
          @MethodNuevo="limpiar"
        />
      </v-row>
      <!-- fn Toolbar  -->

      <v-row>
        <!-- Contenido central --->
        <v-col style="max-height: calc(100vh - 48px - 57px - 64px); overflow-y: scroll">
          <div class="pl-2">
            <v-card color="grey lighten-3">
              <div class="px-2">
                <v-form ref="form" lazy-validation @submit.prevent="">
                  <v-row>
                    <!-- Columna 1--->
                    <v-col cols="12" md="3" sm="6">
                      <v-text-field
                        v-model="filtro.fechaInicial"
                        dense
                        label="Fecha Inicial"
                        outlined
                        type="date"
                        @blur="findAllFacturas(null)"
                        hide-details
                      >
                        <template v-slot:prepend>
                          <i class="fa fa-calendar" style="font-size: 20px; width: 20px"></i>
                        </template>
                      </v-text-field>
                    </v-col>
                    <!-- Fin columna 1 --->

                    <!-- Columna 2 --->
                    <v-col cols="12" md="3" sm="6">
                      <v-text-field
                        v-model="filtro.fechaFinal"
                        dense
                        label="Fecha Final"
                        outlined
                        type="date"
                        @blur="findAllFacturas(null)"
                        hide-details
                      >
                        <template v-slot:prepend>
                          <i class="fa fa-calendar" style="font-size: 20px; width: 20px"></i>
                        </template>
                      </v-text-field>
                    </v-col>
                    <!-- fn columna 2 ---------------------------------------------->

                    <!-- Columna 3 --->
                    <v-col cols="12" md="3" sm="6">
                      <v-autocomplete
                        v-model="filtro.sucursal"
                        :items="sucursales"
                        :search-input.sync="searchSucursales"
                        clearable
                        dense
                        item-text="descripcion"
                        item-value="codigo"
                        label="Estacion"
                        no-filter
                        outlined
                        @blur="findAllFacturas(null)"
                        @change="changeEstacion"
                        hide-details
                      >
                        <template v-slot:prepend>
                          <i class="fa fa-sitemap" style="font-size: 20px; width: 20px"></i>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <!-- fn columna 3 ---------------------------------------------->

                    <!-- Columna 4 --->
                    <v-col cols="12" md="3" sm="6">
                      <v-autocomplete
                      hide-details
                        v-model="filtro.turno"
                        :items="turnos"
                        :search-input.sync="searchTurno"
                        clearable
                        dense
                        item-text="descripcion"
                        item-value="codigo"
                        label="Turno"
                        no-filter
                        outlined
                        @blur="findAllFacturas(null)"
                      >
                        <template v-slot:prepend>
                          <i class="fa fa-clock-o" style="font-size: 20px; width: 20px"></i>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <!-- fn columna 4 ---------------------------------------------->
               
               <v-col cols="12" md="3" sm="6">
                <v-text-field v-model.number="filtro.numfactura" v-on:blur="blurNumerofactura" autocomplete="off" dense hide-details
                                        label="No.Factura:" outlined placeholder=" "
                                        style="font-size: 12px;" @blur="findAllFacturas(null)" @keyup="KeyUpCantidad">
                            <template v-slot:prepend>
                              <i class="fa fa-slack" style="font-size: 18px;"></i>
                            </template>
                          </v-text-field>
               </v-col>

                <v-col cols="12" md="3" sm="6">
                <v-text-field v-model.number="filtro.numcierre" @blur="blurNumeroCierre" autocomplete="off" dense hide-details
                                        label="No.Cierre:" outlined placeholder=" "
                                        style="font-size: 12px;" v-on:blur="findAllFacturas(null)" @keyup="KeyUpCantidad">
                            <template v-slot:prepend>
                              <i class="fa fa-slack" style="font-size: 18px;"></i>
                            </template>
                          </v-text-field>
               </v-col>
                  </v-row>

                  <v-row>
                    <v-col>
                      <v-data-table
                        :footer-props="facturaFooterProps"
                        :headers="facturaHeaders"
                        :items="facturas"
                        :server-items-length="totalFacturas"
                        dense
                        no-data-text="No hay facturas disponibles"
                        @pagination="findAllFacturas"
                        class="elevation-1 TbSize13"
                        id="TbBord"
                      >
                        <template #item.galones="{ item }">
                          <vue-autonumeric
                            id="formdisabledInput"
                            class="fontSize13"
                            v-model.number="item.galones"
                            :an-options="{ minimumValue: 0, decimalPlaces: 2 }"
                            autocomplete="off"
                            dense
                            hide-details
                            outlined
                            disabled
                          ></vue-autonumeric>
                        </template>

                        <template v-slot:item.fecha="props">
                           <!-- <span style="font-size:13px;">{{ props.item.fecha }}</span> -->
                            <v-text-field id="formdisabledInput" v-model="props.item.fecha" class="fontSize13"
                                        dense label=""
                                        outlined type="date" hide-details>
                          </v-text-field>
                        </template>

                         <template v-slot:item.cierre="props">
                        <v-text-field id="formdisabledInput" v-model.number="props.item.cierre" class="fontSize13"
                                        dense label=""
                                        outlined type="number" hide-details>

                          </v-text-field>
                         </template>

                          <template v-slot:item.doccorto="props">
                           <!-- <span style="font-size:13px;">{{ props.item.fecha }}</span> -->
                            <v-text-field id="formdisabledInput"  class="fontSize13"
                                        dense label="" outlined disabled  hide-details :value="props.item.doccorto">
                          </v-text-field>
                         </template>

                          <template v-slot:item.secuencia="props">
                           <!-- <span style="font-size:13px;">{{ props.item.fecha }}</span> -->
                            <v-text-field id="formdisabledInput"  class="fontSize13"
                                        dense label="" outlined disabled  hide-details :value="props.item.secuencia">
                          </v-text-field>
                         </template>
                         
                          <template v-slot:item.turno="props">
                           <!-- <span style="font-size:13px;">{{ props.item.fecha }}</span> -->
                            <!-- <v-text-field id="formdisabledInput"  class="fontSize13"
                                        dense label="" outlined disabled  hide-details :value="props.item.turno">
                          </v-text-field> -->

                    <v-combobox v-model="props.item.cbturno"
                        :items="RTurnoTrabajo" @blur="SelctCbTurnoTrabajo(props.item)"
                         autocomplete="off" dense item-text="descripcion"
                                    label="Turno:"
                                    outlined @change="changeTurnoTranb($event,props.item)"
                                    @focus="cargarTurnoTrabajo" hide-details class="fontSize13">
                          <!-- <template v-slot:prepend>
                            <i class="fa fa-clock-o" style="font-size: 20px;"></i>
                          </template> -->
                        </v-combobox>

                         </template>

                         <template v-slot:item.cajero="props">
                           <!-- <span style="font-size:13px;">{{ props.item.fecha }}</span> -->
                            <v-text-field id="formdisabledInput"  class="fontSize13"
                                        dense label="" outlined disabled  hide-details :value="props.item.cajero">
                          </v-text-field>
                         </template>

                         <template v-slot:item.sucursal="props">
                           <!-- <span style="font-size:13px;">{{ props.item.fecha }}</span> -->
                            <v-text-field id="formdisabledInput"  class="fontSize13"
                                        dense label="" outlined disabled  hide-details :value="props.item.sucursal">
                          </v-text-field>
                         </template>
                         <template v-slot:item.valor="props">
                           <!-- <span style="font-size:13px;">{{ props.item.fecha }}</span> -->
                            <v-text-field id="formdisabledInput"  class="fontSize13"
                                        dense label="" outlined disabled  hide-details :value="props.item.valor">
                          </v-text-field>
                         </template>

                          <template v-slot:item.formaPago="props">
                           <!-- <span style="font-size:13px;">{{ props.item.fecha }}</span> -->
                            <v-text-field id="formdisabledInput"  class="fontSize13"
                                        dense label="" outlined disabled  hide-details :value="props.item.formaPago">
                          </v-text-field>
                         </template>


                         <template v-slot:item.cliente="props">
                           <!-- <span style="font-size:13px;">{{ props.item.fecha }}</span> -->
                            <v-text-field id="formdisabledInput"  class="fontSize13"
                                        dense label="" outlined disabled  hide-details :value="props.item.cliente">
                          </v-text-field>
                         </template>
                         

                        <template #item.acciones="{ item }">
                          <v-btn-toggle>
                            <v-tooltip top>
                              <template #activator="{ on, attrs }">
                                <v-btn color="green" v-bind="attrs" x-small @click="modificarGalones(item)" v-on="on">
                                  <i class="fa fa-edit" style="color: white"></i>
                                </v-btn>
                              </template>
                              <span>Modificar Galones</span>
                            </v-tooltip>

                            <v-tooltip top>
                              <template #activator="{ on, attrs }">
                                <v-btn color="orange" v-bind="attrs" x-small @click="notifAnulando(item)" v-on="on">
                                  <v-icon small>mdi-cancel</v-icon>
                                </v-btn>
                              </template>
                              <span>Anular</span>
                            </v-tooltip>

                            <v-tooltip top>
                              <template #activator="{ on, attrs }">
                                <v-btn color="blue" v-bind="attrs" x-small @click="initReimpresion(item)" v-on="on">
                                  <i class="fa fa-print"></i>
                                </v-btn>
                              </template>
                              <span>Reimprimir</span>
                            </v-tooltip>
                          </v-btn-toggle>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-form>
              </div>
            </v-card>
          </div>
        </v-col>
        <!-- fn Contenido central --->
      </v-row>
    </v-container>

    <!-- Modales -------------------------------------------------------------------------------------------------->

    <!------------otras funciones---------------->
    <v-snackbar
      v-model="aalert.estado"
      :color="aalert.color"
      :timeout="120000"
      :vertical="true"
      style="margin-top: 20%"
      top="top"
    >
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>

    <!-- ------------------------------------------------------ Modal- Notificacion Confirmacion Adicional -->
    <v-dialog transition="fab-transition" label="Modal Otros Ingresos" v-model="notifConfAdicional.estado" persistent
      max-width="60%" max-height="85%">

      <!--------------------- Creacion de Otros Ingresos ------------------------------->
      <div>
        <!-- <div style="max-height:345px;" class="overflow-x-auto">
    </div> -->

     
        <v-col style="background-color:#dd4b39;" class="pa-2 ma-0 py-1 my-0" cols="12" md="12" sm="12">
            <span style="font-size: 22px;"  :class="`d-flex justify-start white--text`"> <i dense class="fa fa-info-circle"> <b> NOTIFICACIÓN</b></i></span>
         </v-col>
        
        <v-card >
          <!-- style="border: 1px solid #000000;" -->
          <!-- columna informacion  -->
          <v-col style="border: 1px solid #000000;"   class="pa-0 ma-0 py-2 my-0" cols="12" md="12" sm="12" :class="`d-flex justify-center`">
            <center >
            <!-- <h2 class="py-5">  </h2> -->
              <code :class="`black--text`" style=" font-size: 25px;border: 1px solid #000000;">
              <b>{{ notifConfAdicional.nombre }}</b>
              </code>
          <!-- LISTA DE OFERTA PEDIDO/NOFACT -->
           <v-card-actions v-if="notifConfAdicional.hasOwnProperty('objTempListOferta')" :class="`d-flex justify-center`">
        <v-row>

          <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12">
          <v-btn  color="green" v-if="notifConfAdicional.Exec == 'contAddListaOfertaPedido'"
            @click.prevent="ContPostrealizarCobro()" large>
            <i style="font-size: 20px;" class="fa fa-check"></i> Si
          </v-btn>

          <v-btn v-if="notifConfAdicional.Exec == 'contAddListaOfertaPedido'" color="red" @click.prevent="contAddListaOfertaPedido()" large>
            <i style="font-size: 20px;" class="fa fa-ban"></i> No
          </v-btn>
          </v-col>

          
        <v-col class="pa-2 ma-0 py-0 my-0" cols="12" md="12" sm="12">
         <v-data-table  :headers="[
                    { text: 'PRODUCTO', value: 'descripcion', sortable: false, class: ['no-gutters black--text'] },
                   { text: 'CANT. PEDIDO', value: 'cantped', sortable: false, class: ['no-gutters black--text'] },
                    { text: 'CANT. FALTANTE', value: 'cantidad', sortable: false, class: ['no-gutters black--text'] },
                  ]" v-model="objTempList"
                  item-key="indx"
                  :loading="loaderTabla"
                  show-select
                  dense :items="notifConfAdicional.objTempListOferta"  :footer-props="arrayPropiedases" :items-per-page="15">

                    <template v-slot:item.descripcion="props">
                      <span style="font-size: 13px; display: none">{{ (props.item.indx = notifConfAdicional.objTempListOferta.indexOf(props.item)) }}</span>
                     <span class="px-1 blue--text" v-if="props.item.paramOfert == true" style=" font-size:12px; border: 1px dashed  #616161;"><b> **OFERTA** </b> </span>
                      <span style="font-size:13px;">{{ props.item.descripcion }}</span>
                    </template>

                    <template v-slot:item.cantidad="props">
                      <span style="font-size:13px;">{{ props.item.cantidad }}</span>
                    </template>
        </v-data-table>
         </v-col>

         

          </v-row> 
          </v-card-actions>
          <!-- LISTA DE OFERTA PEDIDO/NOFACT -->

           <v-card-actions :class="`d-flex justify-center`">
          <v-btn  color="green" v-if="notifConfAdicional.Exec == 'contAnulando'"
            @click.prevent="anularFactura(notifConfAdicional.objTemp)" large>
            <i style="font-size: 20px;" class="fa fa-check"></i> Si
          </v-btn>

          <v-btn  color="red" 
          @click.prevent="cerrarNotificacion" large>
            <i style="font-size: 20px;" class="fa fa-ban"></i> No
          </v-btn>

           </v-card-actions>

          
            </center>
          </v-col>
          <!-- columna informacion  -->

        </v-card>
      </div>

    </v-dialog>
     <!-- ------------------------------------------------------ FIN Modal- Notificacion Confirmacion Adicional  -->

    <!-- fn Modales ----------------------------------------------------------------------------------------------->
  </div>
</template>

<script>
  import BarraBusqueda2 from "../../components/BarraBusquedaDinam"
  import ContenidoBase from "../../components/ContenidoBase"
  import BarraDinamicaLimitePlus from "@/components/BarraDinamicaLimitePlus.vue"
  import VueAutonumeric from "@/components/AutoNumericNuevo.vue"

  export default {
    components: {
      BarraDinamicaLimitePlus,
      BarraBusqueda2,
      ContenidoBase,
      VueAutonumeric,
    },

    mounted() {
      this.findAllFacturas()
      this.findAllSucursales("")
      this.findConfiguracion()
      this.cargarTurnoTrabajo()
    },

    data() {
      return {
      notifConfAdicional: {
      estado: false,
      nombre: "",
      Exec: "",
      objTemp:null
    },
        newFiltro: {
          fechaInicial: new Date().toISOString().split("T")[0],
          fechaFinal: new Date().toISOString().split("T")[0],
          sucursal: null,
          turno: null,
           numfactura:0,
          numcierre:0
        },

        filtro: {
          fechaInicial: new Date().toISOString().split("T")[0],
          fechaFinal: new Date().toISOString().split("T")[0],
          sucursal: null,
          turno: null,
          numfactura:0,
          numcierre:0
        },

        facturas: [],
        totalFacturas: 0,

        sucursales: [],
        searchSucursales: "",
        turnos: [],
        RTurnoTrabajo:[],
        searchTurno: "",

        facturaHeaders: [
          { text: "Fecha", value: "fecha", width: "80px", sortable: false,class: ['no-gutters black--text']  },
          { text: "Documento", value: "doccorto", width: "90px", sortable: false,class: ['no-gutters black--text'] },
          { text: "Secuencia", value: "secuencia", width: "130px", sortable: false,class: ['no-gutters black--text'] },
          { text: "# Cierre", value: "cierre", width: "130px", sortable: false,class: ['no-gutters black--text'] },
          { text: "Turno", value: "turno", width: "150px", sortable: false,class: ['no-gutters black--text'] },
          { text: "Cajero", value: "cajero", width: "150px", sortable: false ,class: ['no-gutters black--text']},
          { text: "Sucursal", value: "sucursal", width: "auto", sortable: false,class: ['no-gutters black--text'] },
          { text: "Valor", value: "valor", width: "150", sortable: false,class: ['no-gutters black--text'] },
          { text: "Forma Pago", value: "formaPago", width: "150px", sortable: false,class: ['no-gutters black--text'] },
          { text: "Galones", value: "galones", width: "120px", sortable: false,class: ['no-gutters black--text'] },
          { text: "Cliente", value: "cliente", width: "250px", sortable: false,class: ['no-gutters black--text'] },
          { text: "Acciones", value: "acciones", width: "auto", sortable: false,class: ['no-gutters black--text'] },
        ],
        facturaFooterProps: {
          itemsPerPageOptions: [10, 20, 30],
        },

        // Reimpresion
        configuracion: null,
        ReimprecionFacturaSeleccionada: {
          secuencia: 0,
          fecha: null,
          ncf: "",
          cliente: "",
          comentario: "",
          turno: 0,
          formapago: "",
          DetalleList: [],
        },

        aalert: {
          estado: false,
          color: null,
        },

        EstadoBtn: {
          BarraTablaDinamicaAprir: false,
          nuevo: true,
          guardar: false,
          eliminar: false,
          anular: false,
        },
      }
    },

    methods: {
      limpiar() {
        Object.assign(this.filtro, this.newFiltro)
        this.findAllFacturas(null)
      },

      /**
       * Muestra una alerta en un dialogo
       * @param {string} mensaje - Mensaje a mostrar
       * @param {string} estado - Estado "bien" o "error"
       */
      alerta(mensaje, estado) {
        this.aalert.nombre = mensaje
        this.aalert.estado = true
        this.aalert.color = estado === "bien" ? "success" : "error"
      },

      findAllSucursales(search) {
        this.$axios
          .get(this.$hostname + this.$hName + "/sucursal", {
            headers: this.$store.getters.GetheadersAxios,
            params: {
              descripcion: search.trim(),
              page: 0,
              size: 15,
            },
          })
          .then((response) => {
            this.sucursales = response.data.content
          })
          .catch((error) => {
            console.error(error)
          })
      },

      findAllTurnos() {
        this.$axios
          .get(this.$hostname + this.$hName + "/turnos-trabajo", {
            headers: this.$store.getters.GetheadersAxios,
            params: {
              descripcion: this.searchTurno,
              page: 0,
              size: 15,
            },
          })
          .then((response) => {
            this.turnos = response.data.content
          })
          .catch((error) => {
            console.error(error)
          })
      },

      findAllFacturas(pagination) {
        ///auditoria-facturas
        let page = pagination ? pagination.page : 1
        let size = pagination ? pagination.itemsPerPage : 10
        let limit= pagination ? pagination.itemsPerPage:10
        let ultimo= pagination? pagination.pageStart :0
        this.$axios
          .get(this.$hostname + this.$hName + "/auditoria-facturas/getAllAuditoriaFactCond", {
            headers: this.$store.getters.GetheadersAxios,
            params: {
              limit: limit,
              ultimo: ultimo ,
              page: page - 1,
              size: size,
              ...this.filtro,
            },
          })
          .then( async response => {
           // this.facturas = response.data.content
            /*var V_FAC = response.data.content
            await Promise.all(V_FAC.map(async (element) => {
                element.cbturno= this.RTurnoTrabajo.filter((ee) => ee.descripcion.trim() === element.turno.trim())[0]
            }));

            this.facturas = V_FAC
            this.totalFacturas = response.data.totalElements*/
        
            var V_FAC = response.data.ListAud
            await Promise.all(V_FAC.map(async (element) => {
                element.cbturno= this.RTurnoTrabajo.filter((ee) => ee.descripcion.trim() === element.turno.trim())[0]
            }));

            this.facturas = V_FAC
            this.totalFacturas = response.data.TbTotalItem
          })
          .catch((error) => {
            console.error(error)
          })
      },

      
      changeEstacion(e){
  //      

  //  if(typeof e === "number"){

  //  }     

           var _this = this
            setTimeout(function() {
              _this.findAllFacturas(null)
            }, 500)

      },

      anularFactura(item) {

        var auditoriaFv={
  facturaPk:{
              secuencia: item.secuencia,
              documento: item.documento,  
              },
              fecha: item.fecha.trim().substr(0, 10) + "T04:00",
              numcierre:item.cierre,
              cbturno: item.cbturno,
              tipo:item.tipo
}
/*
secuencia: item.secuencia,
              documento: item.documento,
    params: {
              auditoriaFv: auditoriaFv
            },          
*/
        
        this.$axios
          .delete(this.$hostname + this.$hName + "/auditoria-facturas", {
            headers: this.$store.getters.GetheadersAxios,
            data: auditoriaFv,
          })
          .then((response) => {
            this.alerta("Factura anulada correctamente!", "bien")
            this.findAllFacturas(null)
            this.cerrarNotificacion()
          })
          .catch((error) => {
            this.alerta("Error! No se pudo anular la factura!", "error")
            console.error(error)
          })
      },

  notifAnulando(notifConfAdicional){
        this.notifConfAdicional= {
      estado: true,
      nombre: `\n¿Desea anular este registro '# SECUENCIA:${notifConfAdicional.secuencia} y # CIERRE: ${notifConfAdicional.cierre}'?`,
      Exec: "contAnulando",
      objTemp: notifConfAdicional,
    }

    return
      },


      modificarGalones(item) {
//typeof DESCPROD === "object" 

if(item.fecha==null || item.fecha!=null && typeof item.fecha==="string" && item.fecha.length<10){
 this.alerta("NOTA: SELECCIONE UNA FECHA", "error")
  return
}

if(typeof item.cierre!="number"){
   this.alerta("NOTA: DIJITE UN NUMERO DE CIERRE!", "error")
return
}

if(item.cbturno==null || item.cbturno!=null && !item.cbturno.hasOwnProperty("codigo") ){
 this.alerta("NOTA: SELECCIONE UN TURNO!", "error")
  return
}

var auditoriaFv={
  facturaPk:{
              secuencia: item.secuencia,
              documento: item.documento,  
              },
              fecha: item.fecha.trim().substr(0, 10) + "T04:00",
              numcierre:item.cierre,
              cbturno: item.cbturno,
              tipo:item.tipo
}

/*params: {
              auditoriaFv:auditoriaFv
            },*/

        this.$axios
          .put(this.$hostname + this.$hName + "/auditoria-facturas", auditoriaFv, {
            headers: this.$store.getters.GetheadersAxios,
            
          })
          .then((response) => {
            this.alerta("Factura modificada correctamente!", "bien")
            this.findAllFacturas(null)
          })
          .catch((error) => {
            this.alerta("Error! No se pudo modificar la factura!", "error")
            console.error(error)
          })
      },

      async findFacturaByPk(item) {
        try {
          const response = await this.$axios.get(
            this.$hostname + this.$hName + `/facturasventas/find/${item.documento}/${item.secuencia}`,
            null,
            {
              headers: this.$store.getters.GetheadersAxios,
            }
          )

          return response.data
        } catch (e) {
          console.error(e)
        }
      },


       async getConduceByPk(item) {
    try {
       const response = await this.$axios.get(this.$hostname +this.$hName +"/conduce/getConduce/"+
          item.secuencia +"/"+item.documento,
          { headers: this.$store.getters.GetheadersAxios })
        // .then((res) => { });
          return response.data
        } catch (e) {
          console.error(e)
        }

       },

      findConfiguracion() {
        this.$axios
          .get(this.$hostname + this.$hName + "/configuraciones/find", {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => {
            this.configuracion = res.data
          })
          .catch((error) => console.error(error))
      },

      async loadPv() {
        this.OtrasConfigPv = {
          caja: null,
          terminal: null,
          impresora: null,
          turno: null,
          cajero: cajero,
          moneda: null,
        }

        if (!localStorage.caja) {
          this.dialogConfigPv = true
        } else {
          var d = JSON.parse(localStorage.caja)
          await this.$axios
            .get(this.$hostname + this.$hName + "/cajas/findbycodigo/" + d.codigo, {
              headers: this.$store.getters.GetheadersAxios,
            })
            .then((res) => {
              this.RestaurarFacturaBusqueda.sucursal = res.data.sucursal
              this.sucursalFactTemporal = res.data.sucursal
              this.caja = res.data
              localStorage.setItem("caja", JSON.stringify(res.data))
              var _this = this
              setTimeout(function () {
                _this.verificarVendedor()
              }, 300)
            })
            .catch((error) => {
              this.dialogConfigPv = true
              console.error(error)
            })
        }

        if (!localStorage.hasOwnProperty("printerSelect") || !this.OtrasConfigPv.hasOwnProperty("impresora")) {
          this.OtrasConfigPv.impresora = null
        } else {
          this.OtrasConfigPv.impresora = JSON.parse(localStorage.printerSelect)
        }
        this.Monedafactura = this.configuraciones.config.monedabase

        this.findAllTerminal()
      },

      findAllImpresoras() {
        this.$axios
          .get("http://localhost:15999/impresora/inicial/listaImpresora")
          .then((res) => {
            this.listImpresora = res.data

            if (res.data.length > 0) {
              this.impresora = res.data[0]
            }
          })
          .catch((error) => {
            console.log(error)
          })
      },

      determinarFormaPago(factura) {
        const camposPago = [
          { campo: "efectivo", forma: "Efectivo" },
          { campo: "cxc", forma: "Credito" },
          { campo: "tarjeta", forma: "Tarjeta" },
          { campo: "cheques", forma: "Cheque" },
          { campo: "valorbonogas", forma: "Bono Gas" },
          { campo: "valorasignacion", forma: "Asignacion" },
          { campo: "valorPruebaMetro", forma: "Prueba Metro" },
          { campo: "valorTraspaso", forma: "Traspaso" },
          { campo: "valordonacion", forma: "Donacion" },
        ]

        // Buscar el primer campo con valor > 0
        for (const pago of camposPago) {
          if (factura[pago.campo] > 0) {
            return pago.forma
          }
        }

        return null
      },

      async initReimpresion(item) {

      console.log('Infr-->',item)

    
      if(item.tipo.includes('Factura')){
        this.imprFactura(item)
      }

      if(item.tipo.includes('Conduce')){
        this.imprConduce(item)
      }

        
      },


async imprFactura(item){
const selectImpre = localStorage.printerSelect !== undefined ? JSON.parse(localStorage.printerSelect) : null

        let impresora = null
        if (selectImpre != null && selectImpre.hasOwnProperty("nombre")) {
          impresora = JSON.parse(localStorage.printerSelect).nombre
        }

        let cajero = ""
        if (this.$store.getters.GetdatosInfUsu.usuario.nombre == null) {
          cajero = this.$store.getters.GetdatosInfUsu.usuario.username
        } else {
          cajero = this.$store.getters.GetdatosInfUsu.usuario.nombre
        }



        let factura = await this.findFacturaByPk(item)

        let fac = {
          secuencia: factura.facturasventaPK.secuencia,
          secdoc: factura.documentoFactura.nombrecorto.trim() + factura.facturasventaPK.secuencia,
          fecha: new Date(factura.fecha).toISOString(),
          ncf: factura.ncf,
          cliente: factura.cliente ? factura.cliente : null,
          comentario: factura.comentario,
          turno: factura.turno ? factura.turno.codigo : null,
          formapago: this.determinarFormaPago(factura),
          DetalleList: factura.facturasventaDetalleList,
          valor: factura.valor,
          moneda: factura.moneda,
          tasa: factura.tasa,
        }

        fac.factura = { ...fac }
        fac.factura.factura = JSON.parse(JSON.stringify(factura))

        const msg = {
          accion: "reprint",
          formato: factura.caja.formatoimpresioncontado.trim(),
          impresora: impresora,
          data: this.configuracion,
          fac: fac,
          cajero: cajero,
          caja: factura.caja,
          operacion: "factura",
          schema: this.$store.getters.GetheadersAxios["X-TENANT-ID"],
        }

        console.log(msg)
        this.imprimir(msg, "factura")
},

async imprConduce(item){

  const selectImpre = localStorage.printerSelect !== undefined ? JSON.parse(localStorage.printerSelect) : null

        let impresora = null
        if (selectImpre != null && selectImpre.hasOwnProperty("nombre")) {
          impresora = JSON.parse(localStorage.printerSelect).nombre
        }else{
      impresora={codigo: 4,nombre: "Microsoft Print to PDF"}
          //this.terminal.impresoras.push({codigo: 4,nombre: "Microsoft Print to PDF"})
        }

        let cajero = ""
        if (this.$store.getters.GetdatosInfUsu.usuario.nombre == null) {
          cajero = this.$store.getters.GetdatosInfUsu.usuario.username
        } else {
          cajero = this.$store.getters.GetdatosInfUsu.usuario.nombre
        }
  let Data_Conduce = await this.getConduceByPk(item)
  Data_Conduce.conduce.DetalleList=Data_Conduce.conduce.conduceInventarioDetalleList
Data_Conduce.conduce.fecha=Data_Conduce.conduce.nuevaFecha

  //fac--factura--conduce
    var fac = Data_Conduce.conduce
    fac.factura = { ...Data_Conduce.conduce }
        fac.factura.conduce = JSON.parse(JSON.stringify(Data_Conduce.conduce))
var msg = {
          accion: "reprint",
          formato: Data_Conduce.caja.formatoimpresioncontado.trim(),
          impresora: impresora,
          data: this.$store.getters.GetConfiguracionGeneral,
          fac: fac,
          cajero: cajero,
          caja: Data_Conduce.caja,
        };


/*const msg = {
          accion: "reprint",
          formato: factura.caja.formatoimpresioncontado.trim(),
          impresora: impresora,
          data: this.configuracion,
          fac: fac,
          cajero: cajero,
          caja: factura.caja,
          operacion: "factura",
          schema: this.$store.getters.GetheadersAxios["X-TENANT-ID"],
        }*/

this.imprimir(msg, "conduce");

},




      imprimir(datos, operacion) {
       datos.schema = this.$store.getters.GetheadersAxios["X-TENANT-ID"]
       datos.operacion = operacion;
        if (datos.formato.trim() === "rolloBlue") {
          if (datos.operacion.trim() === "factura") {
            const FACT = datos.fac.hasOwnProperty("factura") ? datos.fac.factura.factura : datos.fac
            const _this = this
            setTimeout(function () {
              _this.$refs.RefPvImprecionViewer.GetPrintFacturaVenta(FACT)
            }, 800)
          }
        } else {
          if (datos.impresora == null) {
            this.alerta(" seleccione la impresora", "error")
            return
          }

          if (datos.formato === "fiscale") {
            this.$axios
              .get("http://localhost:15999/impresora/imprimir/validad")
              .then((res) => {
                if (res.data.LastError === 0) {
                  this.$axios
                    .post("http://localhost:15999/impresora/imprimir", datos)
                    .then((res) => {})
                    .catch((error) => {
                      console.error(error)
                    })
                }
              })
              .catch((error) => {
                console.error(error)
              })
          } else {
            this.$axios
              .post("http://localhost:15999/impresora/imprimir", datos)
              .then((res) => {})
              .catch((error) => {
                console.error(error)
              })
          }
        }
      },

imprimir2(datos, operacion) {
      datos.schema = this.$store.getters.GetheadersAxios["X-TENANT-ID"]
      datos.operacion = operacion;
      if (datos.formato === "fiscale") {
        this.$axios.get("http://localhost:15999/impresora/imprimir/validad").then(res => {
          console.log(res.data);
          if (res.data.LastError ===0) {
          this.$axios
          .post("http://localhost:15999/impresora/imprimir", datos)
          .then((res) => {
            // this.limpiarPuntoVentaCompleto();
          })
          .catch((error) => console.error(error));
          }else{
            this.alerta("La impresora esta desconectada o esta apagada!!!","error")
            return;
          }
        })
      }else{
        this.$axios
          .post("http://localhost:15999/impresora/imprimir", datos)
          .then((res) => {
            // this.limpiarPuntoVentaCompleto();
          })
          .catch((error) => console.error(error));
      }
    },


 cargarTurnoTrabajo() {
      this.$axios.get(this.$hostname + this.$hName + "/turnos-trabajo/findallBorrado", {
          headers: this.$store.getters.GetheadersAxios,
        })
        .then((res) => (this.RTurnoTrabajo = res.data))
    },


     SelctCbTurnoTrabajo(item) {
          var _this = this
          setTimeout(function() {
            if (item.cbturno == null) {
              item.cbturno = ""
            }
    
            if (!item.cbturno.hasOwnProperty("codigo")) {
              item.cbturno = ""
              item.cbturno = null
              return
            }
          }, 300)
    
        },

    changeTurnoTranb(event,item){

        if (event!=null && typeof DESCPROD === "object" ) {
        item.turno=event.descripcion.trim()
        }
//$event.target.select()

        },




cerrarNotificacion(){
this.notifConfAdicional= {
      estado: false,
      nombre: "",
      Exec: "",
      objTemp:null
    }
},

blurNumeroCierre() {

var _this=this;
setTimeout(function(){ 

if(_this.filtro.numcierre==null){
  _this.filtro.numcierre=0
}

if(_this.filtro.numcierre.length == 0){
  _this.filtro.numcierre=0
}

}, 300);

  },

  blurNumerofactura() {

var _this=this;
setTimeout(function(){ 

if(_this.filtro.numfactura==null){
  _this.filtro.numfactura=0
}

if(_this.filtro.numfactura.length == 0){
  _this.filtro.numfactura=0
}

}, 300);

  },

 KeyUpCantidad(e) {

      //  if(e.key.charCodeAt(0)>=48 & e.key.charCodeAt(0)<=57 ){}

      if (e.target.value.length == 0) {
        e.target.value = 0
      }

      if (e.key) {
        var mynumeral = require("numeral")
        e.target.value = mynumeral(e.target.value).value()

        //console.log(mynumeral(""+this.mensajero.metadeenvios)).value()
        if (e.target.value == null) {
          e.target.value = 0
        }
      } else {
        e.key = ""
      }

      if (e.target.value.length == 0) {
        e.target.value = 0
        e.key = 0
      }
    },

    },

    watch: {
      searchSucursales(val) {
        let search = val ? val.trim() : ""
        this.findAllSucursales(search)
      },

      searchTurno() {
        this.findAllTurnos()
      },
    },
  }
</script>

<style></style>
